/* CLS carousel arrows: scrolls the row inside .cls-product-carousel__wrap.
   Used by the Collection list (Explore by Category) and Featured collection
   (Discover Bestsellers) sections. Runs in the capture phase so it takes over
   from any theme handler on the same buttons. */
(function () {
  if (window.__clsCarouselArrows) return;
  window.__clsCarouselArrows = true;

  function sliderFor(el) {
    var wrap = el.closest('.cls-product-carousel__wrap');
    return wrap ? wrap.querySelector('.slider') : null;
  }

  function stepFor(slider) {
    var item = slider.querySelector('.slider__item');
    var itemWidth = item ? item.getBoundingClientRect().width : slider.clientWidth;
    if (!itemWidth) return slider.clientWidth;
    var perView = Math.max(1, Math.round(slider.clientWidth / itemWidth));
    return itemWidth * perView;
  }

  function updateArrows(slider) {
    var wrap = slider.closest('.cls-product-carousel__wrap');
    if (!wrap) return;
    var prev = wrap.querySelector('.cls-product-carousel__arrow--prev');
    var next = wrap.querySelector('.cls-product-carousel__arrow--next');
    var max = slider.scrollWidth - slider.clientWidth;
    var atStart = slider.scrollLeft <= 2;
    var atEnd = slider.scrollLeft >= max - 2;
    var noScroll = max <= 2;
    if (prev) {
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      prev.classList.toggle('is-disabled', atStart);
      prev.hidden = noScroll;
    }
    if (next) {
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      next.classList.toggle('is-disabled', atEnd);
      next.hidden = noScroll;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cls-product-carousel__arrow');
    if (!btn) return;
    var slider = sliderFor(btn);
    if (!slider) return;
    e.preventDefault();
    e.stopPropagation();
    var dir = btn.classList.contains('cls-product-carousel__arrow--prev') ? -1 : 1;
    slider.scrollBy({ left: dir * stepFor(slider), behavior: 'smooth' });
  }, true);

  function init(root) {
    (root || document).querySelectorAll('.cls-product-carousel__wrap .slider').forEach(function (slider) {
      if (slider.__clsArrowsBound) { updateArrows(slider); return; }
      slider.__clsArrowsBound = true;
      slider.addEventListener('scroll', function () { updateArrows(slider); }, { passive: true });
      window.addEventListener('resize', function () { updateArrows(slider); });
      updateArrows(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
